module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-archaeology-icon-260ab17a00fb933b348ef89f3f0536d1.svg";